<template>
    <div class="foldItem">
        <div class="foldItemTitle" >
            <div class="foldItemTitleLeft" @click="foldItemClick">
                <img :src="foldItem" alt="" :class="{'foldItemTitleOpen': isOpen}">
                <slot name="title"></slot>
            </div>
            <div class="foldItemTitleRight">
                <slot name="titleMore"></slot>
            </div>
        </div>
        <div class="foldItemContent" v-show="isOpen">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import foldItem from '../assets/images/dark/scoring/fold-item.png'
export default {
    name: 'foldItem',
    data() {
        return {
            foldItem,
            isOpen: true,
        }
    },
    methods: {
        foldItemClick() {
            this.isOpen = !this.isOpen;
        }
    }
}
</script>

<style scoped lang="scss">
.foldItem {
    cursor: pointer;
    .foldItemTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #248AFD;
        display: flex;
        align-items: center;
        margin-bottom: 13px;
        .foldItemTitleLeft{
            display: flex;
            align-items: center;
        }
        .foldItemTitleRight{
            margin-left: auto;
        }
    }
    .foldItemTitleOpen {
        transform: rotate(180deg);
    }
    img {
        width: 9px;
        height: 9px;
        margin-right: 3px;
    }
}
</style>